import React from 'react'
import PropTypes from 'prop-types'
import ContextButton from './contextButton'
import compose from 'recompose/compose'
import pure from 'recompose/pure'

const OverflowButton = ({ theme, ...otherProps }) => (
    <ContextButton alt="See More Options" id="overflow_button" icon="ellipsis" theme={theme} {...otherProps} />
)

OverflowButton.propTypes = {
    theme: PropTypes.string,
}

OverflowButton.defaultProps = {
    theme: 'button_rounded_transparent',
}

export default compose(pure)(OverflowButton)
